import { ConstMap } from '@/utils/ConstMap';

export enum FEEDBACK_COLUMNS {
  TICKET = 'tid',
  COMPNAY = 'company',
  CUSTOMER = 'customer',
  TITLE = 'title',
  AGENT = 'agent',
  DATE = 'date',

  // FILTER_KEY
  FEEDBACK_TEXT = 'feedback_text',
  KEYWORD = 'keyword',

  CATEGORY = 'category',
  PRIORITY = 'priority',

  TAG = 'tag',
  HASHTAG = 'hashtag',
  MENTION = 'mention',
  DATE_START = 'start_date',
  DATE_END = 'end_date',
  DATE_RANGE = 'date_range',
  REMARKS = 'remarks',
  QUERY = 'query',

  // open ticket 관련 temp
  TICKET_STATUS = 'source_status', // Source status -> Ticket status
  STATUS = 'status', // AI status -> Analysis scope

  TAXONOMY_TOPIC = 'topic2',
  TAXONOMY = 'taxonomy',
  SNIPPET = 'snippet',

  // 250825 추가 필드
  SOURCE_INFO = 'source_info',
  DIRECTION = 'direction',
  DEMOGRAPHIC = 'demographic',
  PRODUCT = 'product',
  SURVEY_ID = 'survey_id',
  SCORE = 'score',
  ENGAGEMENT = 'engagement',
  SENTIMENT = 'feedback_sentiment',

  LANGUAGE = 'language',

  IMPRESSION = 'impression',

  AD_PREDICTION = 'ad_prediction',

  // entity group query key
  ENTITY_GROUP = 'entity_group_id',

  // SIGNAL ISSUE
  SIGNAL_ISSUE_NAME = 'issue',

  // Mention Type
  CONTENT_ORIGIN = 'content_origin',
}

export enum FEEDBACK_RANGE_COLUMNS {
  MIN_IMPRESSION = 'impression_gte',
  MAX_IMPRESSION = 'impression_lte',
}

export enum DEMOGRAPHIC_COLUMNS {
  LOCATION = 'demographic_location',
  AGE = 'demographic_age',
  GENDER = 'demographic_gender',
  RACE = 'demographic_race',
}

export enum PRODUCT_COLUMNS {
  // ENTRY_TYPE = 'product_entry_type',
  BRAND = 'product_brand_id',
  LINE = 'product_line_id',
  PRODUCT = 'product_id',
  PRODUCT_OPTION = 'product_option_id',
}

export enum SCORE_COLUMNS {
  RATING_SCORE = 'rating_score',
  NPS_SCORE = 'nps_score',
  CES_SCORE = 'ces_score',
  CSAT_SCORE = 'csat_score',
}

export enum SOURCE_COLUMNS {
  SOURCE_TYPE = 'source',
  SOURCE_TARGET = 'source_target',
  DATA_ORIGIN = 'data_origin',
}

export enum SENTIMENT_COLUMNS {
  SENTIMENT_DETAIL = 'sentiment_detail',
  KEY_SENTIMENT = 'sentiment', // key_sentiment
  ENDING_SENTIMENT = 'ending_sentiment',
}

export enum ENGAGEMENT_COLUMNS {
  COLLECT_COUNT = 'engagement_collect_count',
  COMMENT_COUNT = 'engagement_comment_count',
  LIKE_COUNT = 'engagement_like_count',
  SHARE_COUNT = 'engagement_share_count',
  SUBSCRIBERS_COUNT = 'engagement_subscribers_count',
  VIEW_COUNT = 'engagement_view_count',
  VOTES_DOWN_COUNT = 'engagement_votes_down_count',
  VOTES_UP_COUNT = 'engagement_votes_up_count',
  ENGAGEMENT_RATE = 'engagement_rate',
  TOTAL_ENGAGEMENT = 'engagement_total',
}

export enum ENGAGEMENT_RANGE_COLUMNS {
  MIN_COLLECT_COUNT = 'engagement_collect_count_gte',
  MAX_COLLECT_COUNT = 'engagement_collect_count_lte',

  MIN_COMMENT_COUNT = 'engagement_comment_count_gte',
  MAX_COMMENT_COUNT = 'engagement_comment_count_lte',

  MIN_LIKE_COUNT = 'engagement_like_count_gte',
  MAX_LIKE_COUNT = 'engagement_like_count_lte',

  MIN_SHARE_COUNT = 'engagement_share_count_gte',
  MAX_SHARE_COUNT = 'engagement_share_count_lte',

  MIN_SUBSCRIBERS_COUNT = 'engagement_subscribers_count_gte',
  MAX_SUBSCRIBERS_COUNT = 'engagement_subscribers_count_lte',

  MIN_VIEW_COUNT = 'engagement_view_count_gte',
  MAX_VIEW_COUNT = 'engagement_view_count_lte',

  MIN_VOTES_DOWN_COUNT = 'engagement_votes_down_count_gte',
  MAX_VOTES_DOWN_COUNT = 'engagement_votes_down_count_lte',

  MIN_VOTES_UP_COUNT = 'engagement_votes_up_count_gte',
  MAX_VOTES_UP_COUNT = 'engagement_votes_up_count_lte',

  MIN_RATE = 'engagement_rate_gte',
  MAX_RATE = 'engagement_rate_lte',

  MIN_TOTAL_ENGAGEMENT = 'engagement_total_gte',
  MAX_TOTAL_ENGAGEMENT = 'engagement_total_lte',
}

export enum ACCOUNT_COLUMNS {
  ACCOUNT_STARRED = 'account_starred',
  NAME = 'name',
  SENTIMENT = 'latest_sentiment',
  EMPLOYEE_COUNT = 'employee_count',
  MONTHLY_SPEND = 'monthly_spend',
  ANNUAL_REVENUE = 'annual_revenue',
  FEEDBACK_COUNT = 'feedback_count',
  NPS = 'nps',
  CES = 'ces',
  CSAT = 'csat',
  CREATED_AT = 'created_at',
  LAST_ACTIVITY = 'last_activity',

  // FILTER_KEY
  ACTIVE_STATUS = 'active_status',
  PRIMARY_USECASE = 'primary_usecase',
  INDUSTRY = 'industry',
  SIZE = 'size',
  PLAN = 'plan',
  RATING = 'rating',
  NAME_SEARCH = 'account_name',
  ALIAS = 'account_alias',
  KEY = 'account_key',
  TYPE = 'account_type',
  COUNTRY = 'account_country',
  MANAGER = 'account_agent',
  STAGE = 'account_stage',
  AGENT = 'account_agent',
}

export enum CONTACT_COLUMNS {
  NAME = 'name',
  SENTIMENT = 'latest_sentiment',
  EMAIL = 'email',
  PHONE = 'phone',
  DESC = 'desc',
  REFERENCE_LINK = 'reference_link',
  MRR = 'mrr',
  FEEDBACK_COUNT = 'feedback_count',
  NPS = 'nps',
  CES = 'ces',
  CSAT = 'csat',
  LAST_ACTIVITY = 'last_activity',
  EXTERNAL_ID = 'external_id',
  SNS_ID = 'sns_id',
  USAGE = 'usage',
  DATE = 'date',

  // FILTER_KEY
  JOB_FUNCTION = 'job_function',
  NAME_SEARCH = 'contact_name',
  EMAIL_SEARCH = 'contact_email',
  KEY = 'contact_key',
  ALIAS = 'contact_alias',

  ACCOUNT = 'contact_company',
  TYPE = 'contact_type',
  COUNTRY = 'contact_country',
  MANAGER = 'contact_agent',
  PLAN = 'contact_plan',
  STAGE = 'contact_stage',
  AGENT = 'contact_agent',
}

export enum AGENT_COLUMNS {
  NAME = 'name',
  EMAIL = 'email',
  LABEL = 'tags',

  // FILTER_KEY
  ALIAS = 'agent_alias',
  ROLE = 'agent_role',
  TEAM = 'agent_team',
}

export type FullColumnKey =
  | FEEDBACK_COLUMNS
  | ACCOUNT_COLUMNS
  | CONTACT_COLUMNS
  | AGENT_COLUMNS
  | DEMOGRAPHIC_COLUMNS
  | SCORE_COLUMNS
  | SENTIMENT_COLUMNS
  | ENGAGEMENT_COLUMNS
  | SOURCE_COLUMNS;

export const READONLY_COLUMN_KEY: Record<string, string> = {
  [ACCOUNT_COLUMNS.ALIAS]: `r_${ACCOUNT_COLUMNS.ALIAS}`,
  [CONTACT_COLUMNS.ALIAS]: `r_${CONTACT_COLUMNS.ALIAS}`,
  [AGENT_COLUMNS.ALIAS]: `r_${AGENT_COLUMNS.ALIAS}`,
};

export const ORIGINAL_COLUMN_KEY_MAP: Record<string, string> = {
  [CONTACT_COLUMNS.TYPE]: 'type',
  [CONTACT_COLUMNS.COUNTRY]: 'country',
  [ACCOUNT_COLUMNS.TYPE]: 'type',
  [ACCOUNT_COLUMNS.COUNTRY]: 'country',
  [ACCOUNT_COLUMNS.ACTIVE_STATUS]: 'status',
  [ACCOUNT_COLUMNS.STAGE]: 'stage',
};

// 같은 query parameter key를 공유하지만 서로 다른 컬럼으로 지정된 경우 사용
export const COLUMN_FILTER_STATUS_KEY_MAP: Record<string, string> = {
  [CONTACT_COLUMNS.NAME]: CONTACT_COLUMNS.NAME_SEARCH,
  [CONTACT_COLUMNS.EMAIL]: CONTACT_COLUMNS.NAME_SEARCH,
};

export const NUMBER_TYPE_COLUMN: string[] = [
  FEEDBACK_COLUMNS.CATEGORY,
  SOURCE_COLUMNS.SOURCE_TYPE,
  FEEDBACK_COLUMNS.PRIORITY,

  SENTIMENT_COLUMNS.SENTIMENT_DETAIL,
  SENTIMENT_COLUMNS.KEY_SENTIMENT,
  SENTIMENT_COLUMNS.ENDING_SENTIMENT,

  SCORE_COLUMNS.CES_SCORE,
  SCORE_COLUMNS.CSAT_SCORE,
  SCORE_COLUMNS.NPS_SCORE,
  SCORE_COLUMNS.RATING_SCORE,
];

export const FeedbackColumnNameMap = new ConstMap<FullColumnKey, string>([
  [FEEDBACK_COLUMNS.TICKET, 'Ticket'],
  [FEEDBACK_COLUMNS.COMPNAY, 'Company'],
  [FEEDBACK_COLUMNS.CUSTOMER, 'Customer'],
  [FEEDBACK_COLUMNS.TITLE, 'Title'],
  [FEEDBACK_COLUMNS.AGENT, 'Agent'],
  [FEEDBACK_COLUMNS.DATE, 'Date'],
  [FEEDBACK_COLUMNS.FEEDBACK_TEXT, 'Feedback Text'],
  [FEEDBACK_COLUMNS.KEYWORD, 'Keyword'],

  [FEEDBACK_COLUMNS.CATEGORY, 'Category'],
  [FEEDBACK_COLUMNS.PRIORITY, 'Priority'],
  [FEEDBACK_COLUMNS.SENTIMENT, 'Sentiment'],
  [FEEDBACK_COLUMNS.TAG, 'Tag'],
  [FEEDBACK_COLUMNS.HASHTAG, 'Hashtag'],
  [FEEDBACK_COLUMNS.MENTION, 'Mention'],
  [FEEDBACK_COLUMNS.REMARKS, 'Remarks'],
  [FEEDBACK_COLUMNS.CONTENT_ORIGIN, 'Content origin'],

  [FEEDBACK_COLUMNS.DATE_START, 'Date Start'],
  [FEEDBACK_COLUMNS.DATE_END, 'Date End'],
  [FEEDBACK_COLUMNS.DATE_RANGE, 'Date Range'],
  [FEEDBACK_COLUMNS.TICKET_STATUS, 'Source Status'],
  [FEEDBACK_COLUMNS.STATUS, 'Status'],

  [FEEDBACK_COLUMNS.TAXONOMY_TOPIC, 'Taxonomy Topic'],
  [FEEDBACK_COLUMNS.TAXONOMY, 'Taxonomy'],
  [FEEDBACK_COLUMNS.SNIPPET, 'Snippet'],
  [FEEDBACK_COLUMNS.ENTITY_GROUP, 'Entity Group'],
  [FEEDBACK_COLUMNS.COMPNAY, 'Account'],
  [FEEDBACK_COLUMNS.CUSTOMER, 'Contact'],
  [FEEDBACK_COLUMNS.AGENT, 'Agent'],
  [FEEDBACK_COLUMNS.AD_PREDICTION, 'Ad prediction'],

  [SCORE_COLUMNS.RATING_SCORE, 'Rating Score'],
  [SCORE_COLUMNS.NPS_SCORE, 'NPS Score'],
  [SCORE_COLUMNS.CES_SCORE, 'CES Score'],
  [SCORE_COLUMNS.CSAT_SCORE, 'CSAT Score'],

  [FEEDBACK_COLUMNS.SOURCE_INFO, 'Source'],

  [SOURCE_COLUMNS.SOURCE_TYPE, 'Source type'],
  [SOURCE_COLUMNS.SOURCE_TARGET, 'Source target'],
  [SOURCE_COLUMNS.DATA_ORIGIN, 'Source detail'],
]);
